import { utcToMxYmd } from "../utils/dateMx";

/** Agrupa citas por día civil CDMX (YYYY-MM-DD). */
export function groupAppointmentsByMxDate(appointments) {
  const map = new Map();
  for (const appt of appointments || []) {
    const ymd = utcToMxYmd(appt.startUtc);
    if (!ymd) continue;
    if (!map.has(ymd)) map.set(ymd, []);
    map.get(ymd).push(appt);
  }
  for (const list of map.values()) {
    list.sort((a, b) => String(a.startUtc).localeCompare(String(b.startUtc)));
  }
  return map;
}

export function isAppointmentCancelled(appt) {
  return appt?.status === "cancelled";
}

/** Prefijo visible en citas canceladas (carácter especial). */
export const CANCELLED_APPT_MARK = "✕";

export function appointmentStatusPrefix(appt) {
  return isAppointmentCancelled(appt) ? `${CANCELLED_APPT_MARK} ` : "";
}

export function clientDisplayName(appt) {
  const name = (appt?.clientName && String(appt.clientName).trim()) || "Paciente";
  return name;
}
